module.exports = __webpack_public_path__ + "img/photo-0131.db87d7f8.jpg";